import React, { useCallback, useMemo, useState } from 'react';
import { Button, Row, Col } from 'reactstrap';
import CarouselV3 from 'routes/Products/components/CarouselV3';
import { useWLC } from '../../../../products/WLC/contexts/WLCContext';

export default ({ cards, noDescription = true, title = 'Resources' }) => {
  const { handleNav } = useWLC();
  return (
    <div className="pb-5" id="wlc-week-resources">
      <CarouselV3
        cards={cards}
        noDescription={noDescription}
        title={title}
        darkText
        fullWidth
        linkTo="/wlc/resources/"
        className="carousel-full-description"
        handleNav={handleNav}
      >
        <Row className="d-lg-none">
          <Col className="text-center">
            <Button color="primary" size="lg" onClick={() => handleNav(null, null, 'resources')}>
              Explore All Resources
            </Button>
          </Col>
        </Row>
      </CarouselV3>
    </div>
  );
};
